import { makeStyles } from "@material-ui/styles";
import React from "react";
import { UrlHistory } from "./UrlHistory";

const useStyles = makeStyles(() => ({
	headerWrapper: {
		display: "flex",
		justifyContent: "start",
		borderRadius: "4px 4px 0px 0px"
	},
	header: {
		display: "flex",
		color: "#fff",
		alignItems: "start",
		gap: 16
	},
	titleIcon: {
		display: "none"
	},
	title: {
		fontFamily: "Maison Neue Bold",
		fontSize: 30,
		lineHeight: "150%",
		marginBottom: 0,
		color: "#000",
		fontWeight: 700
	}
}));

export const AdminTitle = props => {
	const classes = useStyles();
	const Mobile = props.mobile;

	return (
		<header className={classes.headerWrapper}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					width: "100%"
				}}
			>
				<UrlHistory />
				<div>
					<div className={classes.header}>
						<h1 className={classes.title}>{props.title}</h1>
					</div>
					{props.disableHeader ? null : props.width >= 768 ||
					  !props.mobile ? null : (
						<div>
							<Mobile
								actions={props.actions || null}
								width={props.width}
								buttons={props.generateMobileButtons}
								refreshAction={() => props.refreshAction}
							/>
						</div>
					)}
				</div>
			</div>
		</header>
	);
};
